import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type BackgroundStyle = 'dots' | 'grid' | 'clean' | 'gradient' | 'subtle'

const BG_CLASSES: BackgroundStyle[] = [
  'dots',
  'grid',
  'clean',
  'gradient',
  'subtle',
]

interface BackgroundState {
  background: BackgroundStyle
  setBackground: (bg: BackgroundStyle) => void
}

function applyBackground(bg: BackgroundStyle) {
  const el = document.body
  for (const cls of BG_CLASSES) {
    el.classList.toggle(`bg-${cls}`, cls === bg)
  }
}

export const useBackgroundStore = create<BackgroundState>()(
  persist(
    (set) => ({
      background: 'dots',
      setBackground: (bg: BackgroundStyle) => {
        set({ background: bg })
        applyBackground(bg)
      },
    }),
    { name: 'melodex-background' },
  ),
)

// Apply persisted background on store hydration
useBackgroundStore.subscribe((state) => {
  applyBackground(state.background)
})

// Apply immediately on module load
applyBackground(useBackgroundStore.getState().background)
